import { useEffect, useState } from "react";
import {
    GetLanguageDetectionHierarchiesResponse,
    ModelComputeService,
} from "services/ModelComputeService";

const processingOption = "LanguageDetectionOnAllHierarchies";

const useLanguageDetection = (modelComputeService: ModelComputeService) => {
    const [selectedHierarchiesIds, setSelectedHierarchiesIds] = useState<
        string[]
    >([]);
    const [isEnabled, setIsEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [runOnAll, setRunOnAll] = useState(false);
    const [processingId, setProcessingId] = useState<string>("");

    useEffect(() => {
        const runFn = async () => {
            try {
                setIsLoading(true);
                const [hierarchiesData, activeOptions, processingData] =
                    await Promise.all([
                        modelComputeService
                            .getLanguageDetectionHierarchies()
                            .catch(() => []),
                        modelComputeService
                            .getActiveModelControlProcessingOptions()
                            .catch(() => []),
                        modelComputeService
                            .getModelControlProcessing()
                            .catch(() => []),
                    ]);

                const hierarchies = (
                    hierarchiesData as GetLanguageDetectionHierarchiesResponse[]
                ).map((structure) => structure.organizationStructureMemberId);

                // Get processing id for Language Detection
                const _processingId = processingData.find(
                    (option) => option.processingOption === processingOption,
                )?.id;

                // Check if language detection is in the array of active options
                const isRunningOnAll = activeOptions.some(
                    (option) => option.processingOption === processingOption,
                );

                setProcessingId(_processingId || "");

                setSelectedHierarchiesIds(hierarchies);
                setRunOnAll(isRunningOnAll);
                setIsEnabled(hierarchies.length > 0 || isRunningOnAll);
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        runFn();
    }, [modelComputeService]);

    return {
        runOnAll,
        setRunOnAll,
        isLoading,
        isEnabled,
        setIsEnabled,
        selectedHierarchiesIds,
        setSelectedHierarchiesIds,
        processingId,
    };
};

export default useLanguageDetection;
